module.exports = __webpack_public_path__ + "static/media/Comcast SportsNet Chicago _ 7-21-2014.56e215be.jpg";